/**
 * EN-5318. Patient ids are numeric; anything else that lands on the
 * `/patients/:patientId` route (e.g. `/patients/null`) is not a patient.
 */
export function isValidPatientId(patientId: string | undefined): boolean {
  return !!patientId && /^\d+$/.test(patientId);
}
